import "rxjs"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../../config"
import errorHandlerBuilder from "../errorHandlerBuilder"
import {
  ACTION_COGOLAND_USERS_WITH_STATUS_ERROR,
  ACTION_COGOLAND_USERS_WITH_STATUS_LOADED,
  ACTION_COGOLAND_USERS_WITH_STATUS_LOADING,
  PATH_COGOLAND_USERS_WITH_STATUS
} from "../../constants"

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_COGOLAND_USERS_WITH_STATUS_ERROR)

const epic = (action$, store)=>
  action$.ofType(ACTION_COGOLAND_USERS_WITH_STATUS_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      const {accountId} = action.payload
      const params = {accountId}

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_COGOLAND_USERS_WITH_STATUS}?${$.param(params)}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {
        data.response.data = data.response.data.map((it)=>{
          return it
        })
        return {
          type: ACTION_COGOLAND_USERS_WITH_STATUS_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/cogoland/UsersWithStatusEpic.js